// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__ZjBx1"};